__turbopack_context__.v({
  "benefitsList": "index-module__nGlJyG__benefitsList",
  "buttonContainer": "index-module__nGlJyG__buttonContainer",
  "countdown": "index-module__nGlJyG__countdown",
  "countdownOuter": "index-module__nGlJyG__countdownOuter",
  "entriesContainer": "index-module__nGlJyG__entriesContainer",
  "entriesContainerInner": "index-module__nGlJyG__entriesContainerInner",
  "entriesLinks": "index-module__nGlJyG__entriesLinks",
  "heading": "index-module__nGlJyG__heading",
  "helpContainer": "index-module__nGlJyG__helpContainer",
  "linkBox": "index-module__nGlJyG__linkBox",
  "myAccountBox": "index-module__nGlJyG__myAccountBox",
  "myAccountBoxCentered": "index-module__nGlJyG__myAccountBoxCentered",
  "noSubscription": "index-module__nGlJyG__noSubscription",
  "rogueLink": "index-module__nGlJyG__rogueLink",
  "sideBySide": "index-module__nGlJyG__sideBySide",
  "sideBySideItem": "index-module__nGlJyG__sideBySideItem",
  "subscriptionHeader": "index-module__nGlJyG__subscriptionHeader",
  "subscriptionStatusBadge": "index-module__nGlJyG__subscriptionStatusBadge",
  "subscriptionType": "index-module__nGlJyG__subscriptionType",
});
